import skuUtils from 'utils/Sku';
import helperUtils from 'utils/Helpers';
import anaUtils from 'analytics/utils';
import orderUtils from 'utils/Order';
const { formatSiteCatalystPrice } = helperUtils;

class OrderBindingUtils {
    static getPriceForProductString = item => {
        if (!skuUtils.isGiftCard(item.sku)) {
            if (skuUtils.isSample(item.sku) || skuUtils.isBiReward(item.sku)) {
                return '0';
            } else {
                let itemPrice;

                if (item.isReplenishment) {
                    itemPrice = formatSiteCatalystPrice(item.sku.listPrice);
                } else {
                    itemPrice = item.salePriceSubtotal || item.listPriceSubtotal;
                }

                return anaUtils.removeCurrencySymbol(itemPrice);
            }
        } else {
            return '';
        }
    };

    // Returns the event328 value for a completed Fast Delivery order.
    //   1 = Same Day Delivery (ASAP)
    //   2 = Next Day Delivery
    //   3 = Scheduled Delivery Window (user picked a 2-hour slot)
    // Returns null when the order has no SameDay shipping group.
    static getFastDeliverySelectedValue = orderDetails => {
        const sameDayShippingGroup = orderUtils.getSameDayShippingGroup(orderDetails);

        if (!sameDayShippingGroup) {
            return null;
        }

        const shippingMethodType = sameDayShippingGroup.shippingMethod?.shippingMethodType || '';

        if (shippingMethodType === orderUtils.SHIPPING_METHOD_TYPES.SCHEDULED_SAME_DAY) {
            return 3;
        }

        if (shippingMethodType.includes('Next Day')) {
            return 2;
        }

        return 1;
    };
}

export default OrderBindingUtils;
